import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap, withLatestFrom } from "rxjs/operators";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/ngrx/root.reducer";
import { ESimActions } from "./esim.actions.types";

@Injectable()
export class ESimEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>
  ) {}

  sessionPersistence$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(...[ESimActions.SetEditingProfileId, ESimActions.SetWizardNavState]),
        withLatestFrom(this.store.select("esim")),
        tap((action) => {
          sessionStorage.setItem(
            "NgRxESimPersistence",
            JSON.stringify({
              editingProfileId: action[1].editingProfileId,
              wizardLoadedSectionKey: action[1].wizardLoadedSectionKey,
              wizardLoadedSubSectionKey: action[1].wizardLoadedSubSectionKey,
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
